<app-header></app-header>

<div class="loader-container" *ngIf="loadingSequence">
  <div class="three-strings">
    <span></span>
    <span></span>
    <span></span>
  </div>
  <div class="processing-text">Processing...</div>
</div>

<section style="background:url(./media/small-industry.jpg) no-repeat; background-size: cover; height: 90vh;">
  <div class="container">
    <div class="row">
      <div class="text-center">
        <div class="forgotdiv">
          <mat-stepper>
            <mat-step [stepControl]="otpFormGroup">
              <form [formGroup]="otpFormGroup">
                <ng-template matStepLabel class="bold">OTP Verification for EOI</ng-template>


                <!-- Session Data Display using Textareas -->
                <div class="row mb-3">
                  <div class="col-lg-12 text-start mb-2">
                    <label for="txtUdyam" class="form-label">UDYAM Number</label>
                    <input type="text" id="txtUdyam" class="form-control" [value]="udyamNumber" disabled />
                  </div>
                  <div class="col-lg-12 text-start">
                    <label for="txtMobile" class="form-label">Mobile Number</label>
                    <input type="text" id="txtMobile" class="form-control" [value]="mobileNumber" disabled />
                  </div>
                </div>

                <!-- OTP Field -->
                <div class="row">
                  <div class="col-lg-12 text-start mb-3">
                    <div class="mdc-text-field">
                      <mat-label>Enter OTP <span class="text-danger">*</span></mat-label>
                      <input id="txtOtp" type="text" matInput placeholder="Enter OTP"
                             class="form-control" formControlName="otp" required maxlength="6" minlength="6">
                      <div *ngIf="f['otp'].touched && f['otp'].invalid" class="text-danger mt-1 small">
                        <div *ngIf="f['otp'].errors?.['required']">OTP is required</div>
                        <div *ngIf="f['otp'].errors?.['minlength'] || f['otp'].errors?.['maxlength']">OTP must be 6 digits</div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Buttons -->
                <div>
                  <button (click)="verifyUser()" [disabled]="!isOTPSent || otpFormGroup.invalid" class="btn btn-success">Verify OTP</button>
                  <button (click)="goToLogin()" class="btn btn-danger ms-2">Cancel</button>
                </div>

                <!-- Help -->
                <div class="alert mt-4">
                  <p>Didn't receive OTP? <a href="#" (click)="resendOTP()">Click here to resend</a></p>
                </div>
              </form>
            </mat-step>
          </mat-stepper>
        </div>
      </div>
    </div>
  </div>
</section>

<app-footer></app-footer>
